// @ts-check
import React from 'react';
import { useCombobox } from 'downshift';

/** @typedef {{
  id: string;
  label: string;
  color: string;
}} TagModel */

/** @typedef {{
  items: TagModel[];
  onSelect(tag: TagModel): void;
  className?: string;
}} TagComboboxProps */

/** @type { React.FC<TagComboboxProps> } */
export const TagCombobox = (props) => {
  const { items, onSelect, className = '' } = props;

  // const [input, setInput] = React.useState("");
  const [inputItems, setInputItems] = React.useState(items);

  const {
    getInputProps,
    getMenuProps,
    getComboboxProps,
    highlightedIndex,
    getItemProps
  } = useCombobox({
    items,
    onInputValueChange: ({ inputValue }) => {
      setInputItems(
        items.filter((item) =>
          item.label.toLowerCase().startsWith(inputValue.toLowerCase())
        )
      );
    },
    onSelectedItemChange: ({ selectedItem }) => {
      return selectedItem && onSelect(selectedItem);
    },
  });

  return (
    <div className="_TagCombobox pt-1">
      <div {...getComboboxProps()}>
        <input
          type="text"
          {...getInputProps({
            className: `${className} focus:border-blue-300 focus:outline-none focus:shadow-outline-blue sm:leading-5 sm:text-sm block w-full h-auto px-3 py-2 m-0 font-mono placeholder-gray-400 transition duration-150 ease-in-out border border-gray-300 rounded-md appearance-none`,
            autoFocus: true,
          })}
        />
      </div>
      <ul {...getMenuProps()}>
        {inputItems.map((item, index) => (
          <li
            style={
              highlightedIndex === index ? { backgroundColor: '#bde4ff' } : {}
            }
            key={`${item.id}${index}`}
            {...getItemProps({
              item,
              index,
              className:
                'cursor-pointer flex items-center font-semibold mt-1 px-3 py-2 rounded text-sm',
            })}
          >
            <div
              className="w-5 h-5 mr-2 rounded-full shadow-inner"
              style={{ backgroundColor: item.color }}
            />
            {item.label}
          </li>
        ))}
      </ul>
    </div>
  );
};
